import React, { useState, useEffect } from 'react';
import api from '../../api';

const SupplierLogisticsParameters = () => {
    const [zones, setZones] = useState([]);
    const [loading, setLoading] = useState(true);

    // واکشی داده‌ها
    const fetchData = async () => {
        try {
            const res = await api.get('/operation/supplier-route-zone/');
            setZones(res.data);
            setLoading(false);
        } catch (error) {
            console.error("خطا در دریافت اطلاعات", error);
        }
    };

    useEffect(() => { fetchData(); }, []);

    // مدیریت تغییرات اینپوت‌ها
    const handleInputChange = (zoneId, field, value) => {
        setZones(prev => prev.map(item => 
            item.route_zone === zoneId ? { ...item, [field]: value } : item
        ));
    };

    // ذخیره‌سازی کلی
    const handleSave = async () => {
        try {
            await api.post('/operation/supplier-route-zone/', zones);
            alert("تنظیمات با موفقیت ذخیره شد.");
            fetchData(); // به‌روزرسانی برای پاک شدن احتمالی flagها
        } catch (error) {
            alert("خطا در ذخیره‌سازی");
        }
    };

    if (loading) return <div>در حال بارگذاری...</div>;

    return (
        <div className="p-6 min-h-screen">

            <div className="overflow-x-auto bg-white shadow rounded-lg">
                <table className="w-full text-sm text-right">
                    <thead className="bg-gray-100 uppercase">
                        <tr>
                            <th className="p-4">زون</th>
                            <th className="p-4">محدوده (KM)</th>
                            <th className="p-4">هزینه/کیلو</th>
                            <th className="p-4">هزینه ثابت</th>
                            <th className="p-4">ضریب شکستنی</th>
                            <th className="p-4">ضریب غیرقابل بسته بندی</th>
                            <th className="p-4">ضریب مایعات</th>
                            <th className="p-4">ضریب خورنده</th>
                            <th className="p-4">ضریب اشتعال پذیر</th>
                        </tr>
                    </thead>
                    <tbody>
                        {zones.map((zone) => (
                            <tr key={zone.route_zone} className="border-t">
                                <td className="p-4 font-semibold">{zone.zone_name}</td>
                                <td className="p-4 text-gray-600">{zone.lower_bound} - {zone.upper_bound}</td>
                                <td className="p-4">
                                    <input 
                                        type="number"
                                        className="border rounded p-1 w-24"
                                        value={zone.cost_per_kg}
                                        placeholder={zone.cost_per_kg}
                                        onChange={(e) => handleInputChange(zone.route_zone, 'cost_per_kg', e.target.value)}
                                    />
                                </td>
                                <td className="p-4">
                                    <input 
                                        type="number"
                                        className="border rounded p-1 w-24"
                                        value={zone.fixed_cost}
                                        onChange={(e) => handleInputChange(zone.route_zone, 'fixed_cost', e.target.value)}
                                    />
                                </td>
                                <td className="p-4">
                                    <input 
                                        type="number"
                                        step="0.1"
                                        className="border rounded p-1 w-16"
                                        value={zone.fragile_coefficient}
                                        onChange={(e) => handleInputChange(zone.route_zone, 'fragile_coefficient', e.target.value)}
                                    />
                                </td>
                            <td className="p-4">
                                    <input
                                        type="number"
                                        step="0.1"
                                        className="border rounded p-1 w-16"
                                        value={zone.unpackable_coefficient}
                                        onChange={(e) => handleInputChange(zone.route_zone, 'unpackable_coefficient', e.target.value)}
                                    />
                                </td>
                            <td className="p-4">
                                    <input
                                        type="number"
                                        step="0.1"
                                        className="border rounded p-1 w-16"
                                        value={zone.liquid_coefficient}
                                        onChange={(e) => handleInputChange(zone.route_zone, 'liquid_coefficient', e.target.value)}
                                    />
                                </td>
                            <td className="p-4">
                                    <input
                                        type="number"
                                        step="0.1"
                                        className="border rounded p-1 w-16"
                                        value={zone.corrosive_coefficient}
                                        onChange={(e) => handleInputChange(zone.route_zone, 'corrosive_coefficient', e.target.value)}
                                    />
                                </td>
                            <td className="p-4">
                                    <input
                                        type="number"
                                        step="0.1"
                                        className="border rounded p-1 w-16"
                                        value={zone.flammable_coefficient}
                                        onChange={(e) => handleInputChange(zone.route_zone, 'flammable_coefficient', e.target.value)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="mt-6 flex gap-4">
                <button onClick={handleSave} className="bg-blue-600 text-white px-6 py-2 rounded shadow hover:bg-blue-700">
                    تأیید و ذخیره نهایی
                </button>
                <button onClick={fetchData} className="bg-gray-200 px-6 py-2 rounded hover:bg-gray-300">
                    بازگشت به مقادیر اولیه
                </button>
            </div>
        </div>
    );
};

export default SupplierLogisticsParameters;
